import React, { Component } from 'react';


import Grid from '@material-ui/core/Grid';
import DownIcon from '@material-ui/icons/ArrowDropDown'
import UpIcon from '@material-ui/icons/ArrowDropUp'


import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './../../../../Actions/Dashboard';

import ChartMenu from './../ChartMenu/ChartMenu'
// import CustomTooltip from './DoughnutTooltip';

import GaugeDraw from './GaugeDraw';

// import { colors } from './../../containers/datos';
import './gaugeStyle.css'


class GaugeComponent extends Component {

  getFenomeno = (name) => {
    switch (name) {
      case 'gauges_homicidio': return { id: 1, name: 'Homicidio' }
      case 'gauges_lesiones_per': return { id: 2, name: 'Lesiones personales' }
      case 'gauges_vif': return { id: 3, name: 'Violencia Intrafamiliar' }
      case 'gauges_d_sexuales': return { id: 4, name: 'Delitos sexuales' }
      case 'gauges_h_personas': return { id: 5, name: 'Hurto personas' }
      case 'gauges_h_residencias': return { id: 6, name: 'Hurto residencias' }
      case 'gauges_h_comercio': return { id: 7, name: 'Hurto comercio' }
      case 'gauges_h_motocicletas': return { id: 8, name: 'Hurto motocicletas' }
      case 'gauges_h_automotores': return { id: 9, name: 'Hurto automotores' }
      case 'gauges_incautaciones': return { id: 10, name: 'Incautaciones' }
      case 'gauges_capturas': return { id: 11, name: 'Capturas' }

      // case 'gauges_abigeato': return { id: 1, name: 'Abigeato' }
      // case 'gauges_amenazas': return { id: 2, name: 'Amenazas' }
      // case 'gauges_extorsion': return { id: 4, name: 'Extorción' }
      // case 'gauges_secuestro': return { id: 12, name: 'Secuestro' }
      // case 'gauges_h_entidades_c': return { id: 14, name: 'Daños en bien ajeno' }
      // case 'gauges_feminicidio': return { id: 15, name: 'Feminicidio' }
      // case 'gauges_deformidad': return { id: 16, name: 'Deformidad' }
      // case 'gauges_l_persona_prote': return { id: 17, name: 'Otros' }
      default: return { id: 0, name: '' }
    }
  }

  getAngle = () => {
    let all = this.props.data;
    let hoy = new Date();
    let angle = 0;
    all.map((cv) => {
      if (cv.name === (hoy.getFullYear() - 1).toString())
        angle = cv.value;

      return null;
    });
    return angle;
  }
  getColor = (val) => {
    let all = this.props.data;
    let title = this.props.title.toLowerCase();
    if (title.includes('incautac') || title.includes('recuperac') || title.includes('captur')) {
      if (val === all[0].name) {
        try {
          if (all[0].value > all[1].value)
            return 'green'
          return 'red'
        } catch (e) { return 'green' }
      }
    }
    try {
      if (val === all[0].name) {
        try {
          if (all[0].value > all[1].value)
            return 'red'
          return 'green'
        } catch (e) { return 'red' }
      }
    } catch (e) { }

    return '#555';
  }

  getData = () => {
    let all = this.props.data;
    let resp = [];
    try {
      resp.push({ value: all[1].value * 0.6, color: 'green' });
      resp.push({ value: all[1].value * 0.2, color: 'yellow' });
      resp.push({ value: all[1].value * 0.2, color: 'orange' });
      // resp.push({ value: all[1].value, color: '#555' });
      resp.push({ value: (all[0].value > all[1].value * 1.3) ? all[0].value : all[1].value * 0.3, color: 'red' });
    } catch (e) {
      let years = JSON.parse(JSON.stringify(this.props.dashboard.filter.year))
      let year = 0
      if (years.length) year = years.sort((a, b) => a - b).pop()
      else year = new Date().getFullYear()

      if (all[0].id < year) resp.push({ value: all[0].value, color: 'green' });
      else resp.push({ value: all[0].value, color: 'red' });
    }
    return resp;
  }

  getColorGauge = () => {
    return '#555'
  }

  getPercent = () => {
    let all = this.props.data;
    let mayor = all.reduce((tot, cv) => ((tot.value > cv.value) ? tot : cv));
    let hoy = parseInt(all[0].name);
    let title = this.props.title.toLowerCase();
    if (hoy === parseInt(mayor.name)) {
      //Aumento
      if (title.includes('incautac') || title.includes('recuperac') || title.includes('captur')) {
        try {
          return (
            <p style={{ color: '79a131', }}>
              {Math.abs(parseInt(((all[0].value / all[1].value) - 1) * 100)) + '%'}
              <UpIcon />
            </p>
          )
        } catch (error) {
          return (
            <p style={{ color: '79a131', }}>
              -
            </p>
          )
        }
      }
      try {
        return (
          <p style={{ color: 'red', }}>
            {Math.abs(parseInt(((all[0].value / all[1].value) - 1) * 100)) + '%'}
            <UpIcon />
          </p>
        )
      } catch (error) {
        return (
          <p style={{ color: 'red', }}>
            -
          </p>
        )
      }
    } else {
      if (title.includes('incautac') || title.includes('recuperac') || title.includes('captur')) {
        try {
          return (
            <p style={{ color: 'red', }}>
              {Math.abs(parseInt(((all[0].value / all[1].value) - 1) * 100)) + '%'}
              <DownIcon />
            </p>
          )
        } catch (error) {
          return (
            <p style={{ color: 'red', }}>
              -
            </p>
          )
        }
      }
      try {
        return (
          <p style={{ color: 'green', }}>
            {Math.abs(parseInt(((all[0].value / all[1].value) - 1) * 100)) + '%'}
            <DownIcon />
          </p>
        )
      } catch (error) {
        return (
          <p style={{ color: 'green', }}>
            -
          </p>
        )

      }
    }
  }

  onClick = (uno, dos) => {
    try {
      let feno = this.getFenomeno(this.props.name)
      this.props.actions.selectFilterFenomene({ id: feno.id, value: feno.name }, 'fenomeno')
      this.props.onClickGraphic(this.props.name, feno);
    } catch (e) { }
  }

  getDate = () => {
    try {
      return (
        <Grid container>
          <Grid item xs={12} className="text-center client-label-second-color font-12">
            Actualizado a: {this.props.date.split('T')[0]}
          </Grid>
        </Grid>
      )
    } catch (error) {
      return <></>
    }
  }

  render() {
    const { name, data, title } = this.props;

    return (
      <Grid container id={this.props.name}>
        <ChartMenu graph={name} file={title}
          openDialog={this.props.openDialog} title={this.props.title} watch={this.props.watchMenu}
          seeMore={this.props.seeMore} />
        <Grid container>
          <Grid item xs={3}>
            {
              data.map((val, index) => {
                return <p style={{ textAlign: 'right', color: this.getColor(val.name), fontWeight: 'bold', marginLeft: '10px' }} key={'p-gauge-' + name + index}>{val.name + ': ' + val.value}</p>
              })
            }
          </Grid>
          <Grid item xs={6} className="client-label" style={{ textAlign: 'center' }}>
            <GaugeDraw
              angleValue={this.props.data[0].value}
              colorGauge={this.getColorGauge()}
              data={this.getData()}
              onClickGraphic={this.onClick}
              name={name}
              dataDev={data}
            />
          </Grid>
          <Grid item xs={3}>
            {
              this.getPercent()
            }
          </Grid>
        </Grid>
        {
          this.getDate()
        }
      </Grid>
    )
  }
}

function mapDispathToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

function mapStateToProps(state) {
  return {
    dashboard: state.dashboard,
  }
}

export default connect(mapStateToProps, mapDispathToProps)(GaugeComponent);
